export default "__VITE_ASSET__Dcy8T$bd__"